import NumberInput from './numberInput';

class ShopItem {
	infos = {
		total: 0,
		amount: 0,
		currency: 'CHF',
	};
	constructor($el) {
		let { infos } = this;
		this.$el = $el;
		this.$numberInput = $el.find('.number-input');
		this.$total = $el.find('[data-shop-item="total"]');
		infos.id = $el.data('id');
		// infos.price = $el.data('price');
		infos.price = $el.data('package-price') != '' ? $el.data('package-price') : $el.data('price');
		infos.price.toFixed(2);
		infos.unit = $el.data('unit');
		infos.name = $el.data('name');
		infos.packageSize = $el.data('package-size');

		this.init();
	}

	init = () => {
		this.input = new NumberInput(this.$numberInput);

		this.$numberInput.on('update-input', this.amountChangedHandler);
	};

	amountChangedHandler = (e, val) => {
		let { infos } = this;
		infos.amount = val;
		infos.total = infos.amount * infos.price;

		// always display 2 decimals
		infos.total = infos.total.toFixed(2);	

		if (infos.total > 0) {
			this.$total.text(`${infos.total} ${infos.currency}`);
		} else {
			this.$total.text('');
		}

		this.$el.trigger('update-item', [infos]);
	};
}

export default ShopItem;
